export const apiRoutes = {
  api_r_user_module_moduleBridgeFolder_getModules: {
    path: 'm/folder/get-modules/',
  },
};
